import { CONFIGURATION_FLAGS } from './configurationFlags';

export default defineAppConfig({
  clientHomePage: 'https://centrum-air.com',

  features: CONFIGURATION_FLAGS,
});
